import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify';
import hocFrom from '../../../components/forms/HocFrom';
import Switchrs from '../../../components/inputs/Switchrs';
import Loader from '../../../components/layout/Loader';
import InputDate from "../../../components/inputs/InputDate";
import InputNumber from "../../../components/inputs/InputNumber";

const FormAppDiscount = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {
    const handelValue = (name, value) => {
        switch (name) {
            case "endDate":
                handelsetdataForm({ ...formdata, endDate: value })
                break;
            case "startDate":
                handelsetdataForm({ ...formdata, startDate: value })
                break;
            case "malePercentage":
                handelsetdataForm({ ...formdata, malePercentage: value })
                break;
            case "femalePercentage":
                handelsetdataForm({ ...formdata, femalePercentage: value })
                break;
            case "isActive":
                handelsetdataForm({ ...formdata, isActive: value })
                break;
            default:
                break;
        }
    }

    const Handelsubmit = event => {
        event.preventDefault()
        handelLoadingform(true)

        if (!formdata.malePercentage) {
            toast.error("وارد کردن درصت تخفیف آقا الزامی است", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        if (!formdata.femalePercentage) {
            toast.error("وارد کردن درصت تخفیف خانم الزامی است", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.name ? handelUpdataFrom() : handelSend()
        }

    }
    return (
        loding ? <Loader />

            : <Form className='mt-3' >
                <Form.Row>
                    <Col lg='4' md='4' sm='6' >
                        <InputDate label='تاریخ شروع' name='startDate' handelValue={handelValue}
                            defaultValue={dataUpdate.hasOwnProperty('startDate') ? dataUpdate.startDate.split("T")[0] : ''} />
                    </Col>

                    <Col lg='4' md='4' sm='6' >
                        <InputDate label='تاریخ پایان' name='endDate' handelValue={handelValue}
                            defaultValue={dataUpdate.hasOwnProperty('endDate') ? dataUpdate.endDate.split("T")[0] : ''} />
                    </Col>

                </Form.Row>
                <Form.Row>

                    <Col>
                        <InputNumber label='درصد تخفیف آقا' name='malePercentage' handelValue={handelValue} defaultValue={dataUpdate.malePercentage} />
                    </Col>

                    <Col>
                        <InputNumber label='درصد تخفیف خانم' name='femalePercentage' handelValue={handelValue} defaultValue={dataUpdate.femalePercentage} />
                    </Col>

                    <Switchrs
                        name="isActive"
                        label="فعال باشد؟"
                        handelValue={handelValue}
                        checked={formdata.isActive}
                    />
                </Form.Row>
                <Form.Row>
                    <Col  >
                        <button type='submit' className='btn btn-success' disabled={LoadingForm} onClick={Handelsubmit}>
                            {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.name ? "ارسال تغییر" : "ثبت"}
                        </button>
                    </Col>
                </Form.Row>
            </Form>
    )
}
export default hocFrom(FormAppDiscount)
